import { mergeMap } from './mergeMap';
export function concatMap(project) {
    return mergeMap(project, 1);
}
//# sourceMappingURL=concatMap.js.map